import React, { useState } from 'react';
import ConnectionProfile from '../../../assets/images/user-profile.png';
import { Link } from 'react-router-dom';

const MockupList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    // Add state for managing the number of items to display
    const [displayCount, setDisplayCount] = useState(2);

    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (event.target.closest('.list-edit-dropdown') === null) {
            setOpenDropdown(null);
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    return (
        <div className="card-container mockup-list">
            <div className="connection-header section-header">
                <h3>Mockup List</h3>
            </div>
            <div className="more-pck-wrapper business-list">
                {[...Array(displayCount)].map((_, index) => (
                    <div className="mr-single-package">
                        <div className="mrp-details">
                            <img src={ConnectionProfile} />
                            <div className="package-info">
                                <h4>Cardiast</h4>
                            </div>
                        </div>
                        <div>
                            Canon Smith
                        </div>
                        <div>
                            www.cardiast.com
                        </div>
                        <div className="list-edit-dropdown">
                            <i
                                className="ri-more-2-fill"
                                onClick={() => toggleDropdown(index)}
                            ></i>
                            {openDropdown === index && (
                                <ul>
                                    <li><Link to="/business/update">Update Mockup</Link></li>
                                    <li><Link to="">Share Mockup</Link></li>
                                    <li><Link to="">Delete Mockup</Link></li>
                                </ul>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MockupList;
